<template>
    <div class="hello">
        <div class="const">
            <div class="banner"></div>
            <h1 class="title_1">证能双收全体系，解锁职业新成就</h1>
            <img src="//images.jinku.com/newjk/org/images/home_H5_ti_02.png" class="center_icon">
            <div class="exper" @click="goCeping">立即体验</div>
            <img src="//images.jinku.com/newjk/org/images/home_h5_cen_02_new.png" style="width: 7.5rem;height: 36.2rem;">
            <div class="exper" @click="goCeping">立即体验</div>
            <img src="//images.jinku.com/newjk/org/images/home_h5_cen_02_02.png" style="width: 7.5rem;height: 7.6rem;">
            <div class="exper" style="border: 1px solid #7cc3fe;color: #7cc3fe;" @click="goCeping">立即体验</div>
            <img src="//images.jinku.com/newjk/org/images/home_h5_03_02.png" style="width: 7.5rem; height: 11.08rem;">
            <div class="exper" style="border: 1px solid #7cc3fe;color: #7cc3fe;" @click="goCeping">立即体验</div>
            <img src="//images.jinku.com/newjk/org/images/home_h5_04_02_new.png" style="width: 7.5rem;height: 6.92rem;">
            <div class="exper" style="border: 1px solid #7cc3fe;color: #7cc3fe;" @click="goCeping">立即体验</div>
            <img src="//images.jinku.com/newjk/org/images/home_foot_H5_06.png" style="width: 7.5rem;">
            <div style=" background:#4599F7;padding-top: .3rem;padding-bottom: 1.41rem;">
                <div class="exper" style="background:#FE8636;color: white;margin-bottom: 0;" @click="goCeping">立即体验</div>
            </div>
        </div>
        <bar></bar>
    </div>
</template>

<script>

import http from "../../lib/http";
import bar from "../tab-bar/bar.vue";

export default {
    name: 'Bank-index',
    data() {
        return {
        }
    },
    components:{
        bar
    },
    methods: {
        goCeping:function() {

            if (navigator.userAgent.indexOf(';wealthmanagement-android') != -1) {
                window.bridge.transTab(1);
            }else if (navigator.userAgent.indexOf(';wealthmanagement-iOS') != -1) {
               window.webkit.messageHandlers.tabBarSelect.postMessage('review');
            }else{
                this.getScore();
            }
        },
        getCert(){
            //获取用户的证书信息
            const self = this;
            http({
                method: "post",
                url: "/org/evaluation/get-cert",
                data: ""
            }).then(function(res){
                if(Object.keys(res.data).length !=0){
                    self.$router.push('/cp-result');
                }else{
                    self.$router.push('/ceping');
                }
            }).catch(function(err){

            });
        },
        getScore(){
            //获取用户的证书信息
            const self = this;
            http({
                method: "post",
                url: "/org/evaluation/get-score",
                data: ""
            }).then(function(res){
                if(res.code == 2222603){
                    self.getCert();
                }else{
                    self.$router.push('/cp-result');
                }
            }).catch(function(err){

            });
        },
        home(){
            this.$router.push('/');
        },
        ceping(){
            this.$router.push('/cp-result');
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html,
body,
div,
img,
ul,
li,
p {
    padding: 0;
    margin: 0;
    list-style: none;
}

html {
    font-size: 50px;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
    display: none;
}

html,
body {
    height: 100%;
    overflow: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}

* {
    padding: 0;
    margin: 0;
}
.hello{
    height: 13.34rem;
    position: relative;
}

.banner {
    width: 100%;
    height: 7.7rem;
    background-image: url(//images.jinku.com/newjk/org/images/home_h5_01.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.title_1 {
    width: 100%;
    text-align: center;
    color: #202020;
    font-size: .38rem;
    font-family: SourceHanSansCN;
    font-weight: bold;
    margin-top: .47rem;
    background-image: url(//images.jinku.com/newjk/org/images/bg_home_h5_03.png);
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 1.18rem .18rem;

}

.center_icon {
    width: 100%;
    height: 8.64rem;
}

ul li {
    font-size: .14rem;
    color: white;
}

.exper {
    width: 3rem;
    height: .64rem;
    border: 1px solid #FD9454;
    border-radius: .32rem;
    text-align: center;
    font-size: .28rem;
    color: #FE8636;
    background: white;
    line-height: .64rem;
    margin: auto;
    margin-bottom: .3rem;
}

img {
    vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/index/bank-index.vue